import React, { Component } from 'react';
import RangeSlider from 'react-range-slider-input';
import '../css/rangeSlider.css'

class Slider extends Component {
  render() {
    const { classes, ragParameters, labelParameters, updateFunction } = this.props;
    const { lower, upper } = ragParameters;

    // Accesses relevant element from slider dependency and adds hover titles
    const thumbs = document.querySelectorAll('.range-slider__thumb');
    [...thumbs].sort((a,b) => {
      return a.getAttribute('aria-valuenow') - b.getAttribute('aria-valuenow');
    })
    .forEach((thumb, i) => {
      thumb.setAttribute('title', `${labelParameters[i]} ${(i > 0 ? upper : lower) / 10}`)
    })
    let amberRange = document.querySelector('.range-slider__range');
    if (amberRange) {
      amberRange.setAttribute('title', `Amber range: ${lower / 10} - ${upper / 10}`);
    }

    return (
      <RangeSlider 
        className={classes}
        min="1"
        max="49"
        defaultValue={[ lower, upper ]}
        value={[ lower, upper ]}
        onInput={(e) => updateFunction(e, true)}
        ariaLabel={labelParameters}
      />
    )
  }
}

export default Slider;
